import { ICategoryContentCard } from '@models/ICategoryContentCard';
import CategoryContentCard from '@molecules/CategoryContentCard/CategoryContentCard';

interface Props {
  readonly title: string;
  readonly items: ICategoryContentCard[];
}

const CategoryContentCards = ({ title, items }: Props) => {
  const layoutArray =
    {
      2: [2],
      3: [3],
      4: [2, 2],
      5: [2, 3],
    }[items.length] ?? [];
  const layoutClasses: Record<number, string> = {
    2: 'lg:col-span-6',
    3: 'lg:col-span-4',
  };
  const itemsClasses = layoutArray.reduce<string[]>((acc, rowCount) => {
    const rowClasses = new Array<string>(rowCount).fill(
      layoutClasses[rowCount] ?? ''
    );

    return [...acc, ...rowClasses];
  }, []);

  return (
    <section className="component-padding bg-white text-black-100 dark:bg-black-100 dark:text-white">
      <div className="container">
        <h2 className="h3 mb-7.5 pt-1 xl:mb-10">{title}</h2>

        <div className="flex flex-col gap-y-7.5 lg:grid lg:grid-cols-12 lg:gap-x-4 lg:gap-y-5">
          {items.map((item, index) => (
            <div className={itemsClasses[index]} key={item.title}>
              <CategoryContentCard
                {...item}
                isLargeCard={itemsClasses[index] === 'lg:col-span-6'}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoryContentCards;
